import React from 'react';

const Section = ({ 
  children, 
  className = '', 
  noBorder = false,
  dense = false,
  ...props 
}) => {
  const basePadding = dense 
    ? 'px-0 py-0.5' 
    : 'px-0 py-2';
  const baseClasses = `bg-neutral-0 ${basePadding}`;
  const borderClass = noBorder ? '' : 'hairline';
  const classes = `${baseClasses} ${borderClass} ${className}`;

  return (
    <section className={classes} {...props}>
      {children}
    </section>
  );
};

export default Section; 